import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        <h1 className="footer__title"></h1>
        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>

          <li>
            <a href="#portfolio" className="footer__link">
              Projects
            </a>
          </li>

          <li>
            <a href="#services" className="footer__link">
              Services
            </a>
          </li>
        </ul>

        <div className="footer__social">
          <a
            href="https://github.com/gulsenkeskin"
            className="footer__social-link"
            target="_blank"
          >
            <i className="uil uil-github"></i>
          </a>

          <a
            href="https://www.linkedin.com/in/gulsenkeskin/"
            className="footer__social-link"
            target="_blank"
          >
            <i className="uil uil-linkedin"></i>
          </a>
          <a
            href="https://www.youtube.com/watch?v=TBvpWqhEfVU&t=9s"
            className="footer__social-link"
            target="_blank"
          >
            <i className="uil uil-youtube"></i>
          </a>
          <a
            href="https://stackoverflow.com/users/14745090/g%c3%bclsen-keskin_"
            className="footer__social-link"
            target="_blank"
          >
            <i className="uil uil-question-circle"></i>
          </a>
          <a
            href="https://dev.to/gulsenkeskin"
            className="footer__social-link"
            target="_blank"
          >
            <i className="uil uil-blogger"></i>
          </a>
          <a
            href="https://medium.com/@gulsenkeskin2"
            className="footer__social-link"
            target="_blank"
          >
            <i className="uil uil-medium-m"></i>
          </a>
          {/* <a
            href="https://twitter.com/gulsenkeskin_"
            className="footer__social-link"
            target="_blank"
          >
            <i className="uil uil-twitter"></i>
          </a> */}
        </div>
        <span className="footer__copy">
          &#169; Gülsen Keskin 2024 - All rigths reserved
        </span>
      </div>
    </footer>
  );
};

export default Footer;
